var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          !_vm.readonly
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.vop_provider.name"),
                    },
                    model: {
                      value: _vm.NameVopProvider,
                      callback: function ($$v) {
                        _vm.NameVopProvider = $$v
                      },
                      expression: "NameVopProvider",
                    },
                  }),
                ],
                1
              )
            : _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-read-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("common.vop_provider.name"),
                      inputValue: _vm.NameVopProvider,
                    },
                  }),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }